// @flow

import React from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "ramda";

import { type ErrosSelecao } from "../../../model";

import {
  type State,
  comGeradorDePeriodo,
  getAtivosCarteiraSelecionados,
  i18n,
  getAjusteDiasSelecionado,
  getPeriodicidadeSelecionada,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  getJanelaMovelSelecionada,
  analiseValorDaMedida,
} from "../../../state";

import {
  SelecaoAtivoSelecionavel,
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoJanelaMovel,
} from "../configuracoes";

export const criaFuncaoValidacaoPeriodoDiarioComAtivo = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAtivosCarteiraSelecionados(state))) {
    erros.ativoNaoSelecionado = translate(
      "configuracaoRelatorio.erroMedidaSemAtivoSelecionado"
    );
  }

  return erros;
};

export const processarPeriodoDiarioComAtivo = comGeradorDePeriodo(
  (state, medidas) => {
    const ativos = getAtivosCarteiraSelecionados(state);
    const ajusteDias = getAjusteDiasSelecionado(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const periodicidade = getPeriodicidadeSelecionada(state);
    const janelaMovel = getJanelaMovelSelecionada(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return ativos.flatMap(({ id, nome, tipoItemSelecionavel }) =>
        medidas.map(medidasSelecionada => ({
          ...medidasSelecionada,
          idAtivoComprado: id,
          nomeAtivoComprado: nome,
          tipoAtivoComprado: tipoItemSelecionavel,
          janelaMovel,
          ...analiseValorDaMedida(medidasSelecionada, state),
        }))
      );
    } else {
      return ativos.flatMap(({ id, nome, tipoItemSelecionavel }) =>
        medidas.map(medidasSelecionada => ({
          ...medidasSelecionada,
          idAtivoComprado: id,
          nomeAtivoComprado: nome,
          tipoAtivoComprado: tipoItemSelecionavel,
          periodicidade,
          ajusteDias,
          dataBase,
          janelaMovel,
          ...analiseValorDaMedida(medidasSelecionada, state),
        }))
      );
    }
  }
);

const PeriodoDiarioComAtivo = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoAtivoSelecionavel />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <SelecaoAtivoSelecionavel />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />

        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida--flex">
            <SelecaoPeriodo exibirPeriodicidade={false} />
          </div>

          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PeriodoDiarioComAtivo;
